const defaultState = {
    records: [],
	clinic: null,
	period: null,
}

const SET_RECORDS = "SET_RECORDS"
const SET_CLINIC = "SET_CLINIC"
const SET_PERIOD = "SET_PERIOD"

export const recordsTableReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_RECORDS:
            return {...state, records: action.payload}
		case SET_CLINIC:
			return {...state, clinic: action.payload}
		case SET_PERIOD:
			return {...state, period: action.payload}

        default:
            return state
    }
}

export const setRecordsAction = (payload) => ({type: SET_RECORDS, payload})
export const setClinicAction = (payload) => ({type: SET_CLINIC, payload})
export const setPeriodAction = (payload) => ({type: SET_PERIOD, payload})
